import { useSelector } from "react-redux";

import { selectFavoriteBarbershops } from "../../ducks/user";

export const useFavoriteBarbershopIds = () => {
  const favoriteIds = useSelector(selectFavoriteBarbershops);
  return favoriteIds;
};
